import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, Messaging, deleteToken } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyBjZp1rwkhRA8kbyDPqv8fd2GMPqZr81UA",
  authDomain: "selectrow-dev-c9c5d.firebaseapp.com",
  projectId: "selectrow-dev-c9c5d",
  storageBucket: "selectrow-dev-c9c5d.firebasestorage.app",
  messagingSenderId: "1067314051883",
  appId: "1:1067314051883:web:3c3597b923293cd20fe36e",
  measurementId: "G-X6LM1V721S"
};

const app = initializeApp(firebaseConfig);
export const messaging: Messaging | null = (() => {
  try { return getMessaging(app); } catch { return null; }
})();

export async function requestFcmToken(vapidKey?: string) {
  if (!messaging) return null;
  try {
    // Ensure our SW is registered so background messages work
    if ('serviceWorker' in navigator) {
      try {
        await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      } catch {}
    }
    const token = await getToken(messaging, { vapidKey, serviceWorkerRegistration: await navigator.serviceWorker.getRegistration() || undefined });
    return token || null;
  } catch {
    return null;
  }
}

export function onForegroundMessage(cb: Parameters<typeof onMessage>[1]) {
  if (!messaging) return () => {};
  return onMessage(messaging, cb);
}

export async function refreshFcmToken(vapidKey?: string) {
  if (!messaging) return null;
  try {
    // Best-effort delete and re-get
    try { await deleteToken(messaging); } catch {}
    if ('serviceWorker' in navigator) {
      try {
        await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      } catch {}
    }
    const token = await getToken(messaging, { vapidKey, serviceWorkerRegistration: await navigator.serviceWorker.getRegistration() || undefined });
    return token || null;
  } catch {
    return null;
  }
}
